import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';

export default function CarpentryOrderInfo(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [productionOrder] = useState(props.productionOrder);
    const formattedDateTime = new Date(productionOrder.productionDate).toLocaleString("nl-BE");

    return <div className={classes.orderInfo}>
        <div className={classes.label}>
            Ordern°
        </div>
        <div className={classes.info}>
            <div className={classes.reference}>
                {productionOrder.productionOrderReference}
            </div>
        </div>

        <TableContainer component={Paper} className={classes.paper}>
            <Table key={"CarpentryOrderArticleTable_" + productionOrder.productionOrderReference} className={classes.table} aria-label="customized table">
                <TableBody key={"CarpentryOrderArticleTableBody_" + productionOrder.productionOrderReference}>
                    <TableRow key={"CarpentryOrderArticleTableDate_" + productionOrder.productionOrderReference}  className={classes.row}>
                        <TableCell className={classes.nameCell}>
                            {t("Production date")}
                        </TableCell>
                        <TableCell className={classes.infoCell}>{formattedDateTime}</TableCell>
                    </TableRow>
                    <TableRow key={"CarpentryOrderArticleTableDepartment_" + productionOrder.productionOrderReference}  className={classes.row}>
                        <TableCell className={classes.nameCell}>
                            {t("Department")}
                        </TableCell>
                        <TableCell className={classes.infoCell}>{productionOrder.department}</TableCell>
                    </TableRow>
                    <TableRow key={"CarpentryOrderArticleTableLocation_" + productionOrder.productionOrderReference}  className={classes.row}>
                        <TableCell className={classes.nameCell}>
                            {t("Location")}
                        </TableCell>
                        <TableCell className={classes.infoCell}>{productionOrder.location}</TableCell>
                    </TableRow>
                    <TableRow key={"CarpentryOrderArticleTableDescription_" + productionOrder.productionOrderReference}  className={classes.row}>
                        <TableCell className={classes.nameCell}>
                            {t("Description")}
                        </TableCell>
                        <TableCell className={classes.infoCell}>{productionOrder.description}</TableCell>
                    </TableRow>
                    <TableRow key={"CarpentryOrderArticleTableCustomer_" + productionOrder.productionOrderReference}  className={classes.row}>
                        <TableCell className={classes.nameCell}>
                            {t("Client")}
                        </TableCell>
                        <TableCell className={classes.infoCell}>{productionOrder.customer}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    </div>
}

const useStyles = makeStyles({
    orderInfo: {
        float: "left",
        paddingLeft: "40px",
        width: "45%",
        boxSizing: "border-box",
        display: 'flex',
        flexDirection: 'column',
        marginBottom: "20px"
    },
    reference: {
        float: "left",
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        marginBottom: "10px"

    },
    quantity: {
        float: "right",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        marginBottom: "10px"

    },
    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block",
        marginTop: "15px"
    },
    info: {

        color: "#020100",
        display: "block",
    },
    orderTable: {
        display: "block"
    },

   
    paper: {
        boxShadow: 'none'
    },
    nameCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        width: "120px"
    },
    infoCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
});